import { Component, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { ISelect } from 'app/shared/models/select.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { IStudy } from 'app/shared/models/recruitment/study.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OpeningService } from '../opening/opening.service';
import { SecurityService } from 'app/shared/services/security.service';
import { CustomerService } from '../quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService, IDtoEmployeeModuleProfile } from '../security/identity.service';
import { RecruitmentService } from '../recruitment/recruitment.service';
import { EmployeeService } from '../employee.service';
import { IDtoRequisitionPosition } from 'app/shared/models/opening/dto-requisition-position.model';
import { IDtoPayrollEmployeeDetail } from 'app/shared/models/employee/dto-payroll-employee-detail.model';
import { WorkingDayService } from '../quote/working-day.service';
import { PositionService } from '../quote/position.service';
import { PayrollService } from '../payroll.service';
import { OrganizationService } from '../organization/organization.service';
import { DatePipe } from '@angular/common';
import { IDtoEmployeeBasicData } from 'app/shared/models/employee/dto-employee-basic-data.model';
import { IDtoEmployeePaymentData } from 'app/shared/models/employee/dto-employee-payment-data.model';
import { IDtoEmployeeUpdatePayroll } from 'app/shared/models/employee/dto-employee-update-payroll.model';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { WorkLeaveService } from '../request/workLeave.service';
@Component({
  selector: 'app-employee-update',
  styleUrls: ['./employee-update.style.scss'],
  templateUrl: 'employee-update.template.html'
})
export class EmployeeUpdateComponent implements OnDestroy, OnInit {
  private activateSave: IDtoEmployeeModuleProfile;
  private profile: string;
  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if (this.formGeneralData.dirty
      || this.formStudy.dirty)
      $event.returnValue = '';
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.formGeneralData.dirty
      || this.formStudy.dirty) {
      const confirmation = window.confirm('No se han guardado los cambios ¿Desea continuar?');
      return Observable.of(confirmation);
    }
    return true;
  }

  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formGeneralData: FormGroup;
  private formStudy: FormGroup;
  private formPersonalData: FormGroup;
  private formPaymentData: FormGroup;
  private formBasicData: FormGroup;
  /**Notificaciones */
  private configToast: any;
  @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
  @ViewChild('addSwalBankAccount', { static: false }) private addSwalBankAccount: SwalComponent;
  /**Catalogos */
  private catalogGenders: ISelect[];
  private catalogMaritalStatus: ISelect[];
  private catalogStates: Observable<ISelect[]>;
  private catalogSchoolLevels: Observable<IDtoCatalog[]>;
  private catalogRequisitions: ISelect[];
  private catalogEducationLevels: Observable<IDtoCatalog[]>;
  private catalogDocumentsReceived: Observable<IDtoCatalog[]>;
  private catalogTrademarks: Observable<IDtoCatalog[]>;
  private catalogEmployerRegisters: Observable<IDtoCatalog[]>
  private catalogTypesSalary: IDtoCatalog[]
  private catalogMethodPayments: IDtoCatalog[]
  private catalogBenefitCategories: IDtoCatalog[];
  private catalogAccountingSegments: IDtoCatalog[];
  private catalogFamilyMedicalUnits: IDtoCatalog[];
  private catalogSalaryZones: IDtoCatalog[];
  private catalogPaymentForms: Observable<IDtoCatalog[]>;
  private catalogBanks: IDtoCatalog[]
  private catalogEmployees: IDtoCatalog[];
  private catalogContractTypes: Observable<ISelect[]>;
  private catalogPatrimonialRegimes: IDtoCatalog[];
  private catalogPayrollOfficers: Observable<ISelect[]>;
  private catalogSupervisors: Observable<ISelect[]>;
  private catalogPhoneCompanies: Observable<ISelect[]>;
  private catalogPhonePlans: Observable<ISelect[]>;
  private catalogWorkingDays: IDtoCatalog[];
  private catalogTowns: ISelect[];
  private generalData = {} as IDtoPayrollEmployeeDetail;
  private requisitionPosition = {} as IDtoRequisitionPosition;
  /**Variables */
  private section: string;
  public nav: any;
  private action = 'new';
  private navigationSubscription: any;
  public documents: Subject<IDocument[]> = new Subject<IDocument[]>();
  public constructor(public datepipe: DatePipe, private recruitmentService: RecruitmentService
    , private openingService: OpeningService
    , private workingDayService: WorkingDayService
    , private formBuilder: FormBuilder
    , public snotifyService: SnotifyService
    , public configGeneral: AppConfig
    , private router: Router
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
    , private customerService: CustomerService
    , private identityService: IdentityService
    , private employeeService: EmployeeService
    , private positionService: PositionService
    , private payrollService: PayrollService
    , private organizationService: OrganizationService
    , private dismissalService: WorkLeaveService) {
    this.nav = document.querySelector('nav.navbar');
    this.profile = this.securityService.getProfileStorage('EmployeeUpdate');
    this.initializeFormGeneralData();
    this.initializeFormStudy();
    this.initializeFormPersonalData();
    this.initializeFormPaymentData();
    this.initializeFormBasicData();
    this.configToast = configGeneral.getConfigToast();
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  private updateInput(input: string, inputUpdate: string): void {
    if (this.formGeneralData.get(input).value == '' && this.formGeneralData.get(inputUpdate).value == '') {
      this.formGeneralData.get(input).setValidators([Validators.required, Validators.maxLength(35)]);
      this.formGeneralData.get(inputUpdate).setValidators([Validators.required, Validators.maxLength(35)]);
      return;
    }
    if (this.formGeneralData.get(input).value == '') {
      this.formGeneralData.get(input).setValidators([Validators.maxLength(35)]);
    } else {
      this.formGeneralData.get(input).setValidators([Validators.required, Validators.maxLength(35)]);
    }
    if (this.formGeneralData.get(inputUpdate).value == '') {
      this.formGeneralData.get(inputUpdate).setValidators([Validators.maxLength(35)]);
    } else {
      this.formGeneralData.get(inputUpdate).setValidators([Validators.required, Validators.maxLength(35)]);
    }
    this.formGeneralData.get(inputUpdate).updateValueAndValidity();
  }
  public ngOnInit(): any {
    this.activateSave = this.identityService.activateSaveForm(this.profile);
    if (this.configurationService.isReady) {
      this.obtenerCatalogos();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.obtenerCatalogos();
      });
    }
    this.nav.className += ' white-bg';
    this.route.params.subscribe((params) => {
      if (params['id']) {
        setTimeout(() => {
          this.spinner.show();
          this.getEmployeeDataPayrollById(Number(params['id']));
          this.action = params['action'];
          this.workingDayService.getCatalogWorkingDays(params['companyPayId']).subscribe(x => {
            this.catalogWorkingDays = x;
          });
          this.catalogEmployerRegisters = this.organizationService.getCatalogEmployerRegistersByCustomerId(params['customerId']);
        }, 2);

      }
    });
  }
  private readFormControlEmployeeModule(control: string): boolean {
    return this.identityService.readFormControlEmployeeModule(this.profile, control);
  }
  private writeFormControlEmployeeModule(control: string): boolean {
    return !this.identityService.writeFormControlEmployeeModule(this.profile, control);
  }
  private getEmployeeDataPayrollById(employeeId: number): void {
    this.employeeService.getEmployeeDataPayrollById(employeeId).subscribe((res) => {
      this.generalData = res.data as IDtoPayrollEmployeeDetail;
      this.generalData.alimony = this.generalData.jobCandidateRecruiterComment.alimony;
      this.generalData.hasInfonavit = this.generalData.jobCandidateRecruiterComment.hasInfonavit;
      this.getCatalogTowns(this.generalData.stateId);
      this.generalData.birthDate = new Date(this.generalData.birthDate);
      this.generalData.hiringDate = this.datepipe.transform(this.generalData.hiringDate, 'dd-MM-yyyy');
      this.generalData.laborSeniorityDate = this.datepipe.transform(this.generalData.laborSeniorityDate, 'dd-MM-yyyy');
      this.generalData.employeeBasicData.laborSeniorityDate = this.generalData.laborSeniorityDate;
      this.generalData.employeeBasicData.hasInfonavit = this.generalData.jobCandidateRecruiterComment.hasInfonavit;
      this.generalData.employeeBasicData.alimony = this.generalData.jobCandidateRecruiterComment.alimony;
      this.generalData.maritalStatusId = this.generalData.maritalStatusId.toString();
      this.generalData.stateId = this.generalData.stateId.toString();
      this.generalData.townId = this.generalData.townId.toString();
      if (this.generalData.phoneCompanyId != null) {
        this.generalData.phoneCompanyId = this.generalData.phoneCompanyId.toString();
      }
      if (this.generalData.phonePlanId != null) {
        this.generalData.phonePlanId = this.generalData.phonePlanId.toString();
      }
      this.generalData.stateBirthId = this.generalData.stateBirthId.toString();
      if (this.generalData.jobCandidateLevelEducation !== null) {
        this.generalData.jobCandidateLevelEducation.periodFrom = new Date(this.generalData.jobCandidateLevelEducation.periodFrom);
        this.generalData.jobCandidateLevelEducation.periodTo = new Date(this.generalData.jobCandidateLevelEducation.periodTo);
        this.formStudy.patchValue(this.generalData.jobCandidateLevelEducation);
      }
      if (this.generalData.jobCandidateRecruiterComment.trackingStatusId != 13) {
        this.getLastDismissalDate(this.generalData.id);
      }
      if (this.generalData.employeeTaxData.length > 0) {
        let taxData = this.generalData.employeeTaxData[0];
        this.formPersonalData.get('taxStreet').setValue(taxData.street);
        this.formPersonalData.get('taxInteriorNumber').setValue(taxData.interiorNumber);
        this.formPersonalData.get('taxExternalNumber').setValue(taxData.externalNumber);
        this.formPersonalData.get('taxSuburb').setValue(taxData.suburb);
        this.formPersonalData.get('taxPostalCode').setValue(taxData.postalCode);
        this.formPersonalData.get('taxState').setValue(taxData.state);
        this.formPersonalData.get('taxTown').setValue(taxData.town);
        this.formPersonalData.get('taxRegime').setValue(taxData.regime);
        this.formPersonalData.get('taxIncorporationDate').setValue(taxData.incorporationDate);
      }
      this.getRequisitionByPositionId(this.generalData.jobCandidateRecruiterComment.positionId);
      this.documents.next(this.generalData.jobCandidateDocuments);
      this.spinner.hide();
    },
    (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.message, 'error');
    });
  }
  private getRequisitionByPositionId(requisitionId: number): void {
    this.spinner.show();
    this.openingService.getRequisitionByPositionId(requisitionId).subscribe((res) => {
      this.requisitionPosition = res;
      this.generalData.job = `${res.codeJob}-${res.job}`;
      this.generalData.positionNo = `${res.positionNo}-${res.position}`;
      this.generalData.companyName = res.companyName;
      this.generalData.projectName = res.projectName;
      this.generalData.planName = res.planName;
      this.generalData.customer = res.customer;
      this.generalData.zoneName = res.zoneName;
      this.generalData.townName = res.town;
      this.generalData.supervisorId = res.supervisorId != null ? res.supervisorId.toString() : null;
      this.generalData.payrollOfficerId = res.payrollOfficerId != null ? res.payrollOfficerId.toString() : null;
      this.generalData.workingDayId = res.workingDayId != null ? res.workingDayId : null;
      this.generalData.employeeBasicData.requisitionContractTypeId = res.requisitionContractTypeId.toString();
      this.generalData.employeeBasicData.employerRegisterId = res.location;
      this.generalData.employeePaymentData.dailySalary = res.dailySalary;
      this.generalData.employeePaymentData.classification = res.classification;
      this.formGeneralData.patchValue(this.generalData);
      this.formPersonalData.patchValue(this.generalData);
      this.formPaymentData.patchValue(this.generalData.employeePaymentData);
      this.formBasicData.patchValue(this.generalData.employeeBasicData);
      this.getIntegratedDailySalary(this.requisitionPosition.companyPayId, this.generalData.employeeNum, this.requisitionPosition.codePayroll);
      this.getBusinessPhone(this.generalData.uKey);
      if (this.generalData.typePosition == '1') {
        this.catalogEmployerRegisters = this.organizationService.getCatalogEmployerRegisterOfficesByProjectCustomerId(this.requisitionPosition.projectId);
      }
      this.spinner.hide();
    });
  }
  private getIntegratedDailySalary(codeNomCompanyNum: string, codeNomEmployeeNum: string, codeNomPayroll: string): void {
    this.payrollService.getIntegratedDailySalary(codeNomCompanyNum, codeNomEmployeeNum, codeNomPayroll).subscribe((res) => {
      this.generalData.integratedDailySalary = res;
      this.formPaymentData.get('integratedDailySalary').setValue(this.generalData.integratedDailySalary);
      this.spinner.hide();
    });
  }
  private getBusinessPhone(uKey: string): void {
    this.employeeService.getBusinessPhone(uKey).subscribe((res) => {
      this.formGeneralData.get('businessPhone').setValue(res);
      this.spinner.hide();
    });
  }
  private getLastDismissalDate(employeeId: number): void {
    this.dismissalService.getLastDismissalDate(employeeId).subscribe((res) => {
      let date = this.datepipe.transform(res, 'dd-MM-yyyy');
      this.formGeneralData.get('dismissalDate').setValue(date);
      this.spinner.hide();
    });
  }
  private changeMaritalStatus(dto: ISelect): void {
    if (dto == undefined) {
      this.formPersonalData.get('patrimonialRegimeId').setValidators(null);
      this.formPersonalData.get('patrimonialRegimeId').setValue(null);
      return;
    }
    if (dto.text != 'CASADO') {
      this.formPersonalData.get('patrimonialRegimeId').setValidators(null);
      this.formPersonalData.get('patrimonialRegimeId').setValue(null);
    } else {
      this.formPersonalData.get('patrimonialRegimeId').setValidators([Validators.required]);
    }
    this.formPersonalData.get('patrimonialRegimeId').updateValueAndValidity();
  }
  private obtenerCatalogos(): void {
    this.catalogStates = this.recruitmentService.getCatalogStates();
    this.recruitmentService.getCatalogMaritalStatus().subscribe(x=> {
      this.catalogMaritalStatus = x;
    });
    this.catalogSchoolLevels = this.employeeService.getCatalogSchoolLevels();
    this.catalogEducationLevels = this.employeeService.getCatalogEducationLevels();
    this.catalogDocumentsReceived = this.employeeService.getCatalogDocumentsReceived();
    this.catalogTrademarks = this.customerService.getCatalogCustomers();
    this.catalogPayrollOfficers = this.openingService.getCatalogPayrollOfficers();
    this.catalogSupervisors = this.openingService.getCatalogSupervisors();
    this.catalogPhoneCompanies = this.recruitmentService.getCatalogPhoneCompanies();
    this.catalogPhonePlans = this.recruitmentService.getCatalogPhonePlans();
    this.employeeService.getCatalogOfficeEmployeesActives().subscribe(x => {
      this.catalogEmployees = x;
    });
    this.recruitmentService.getCatalogPatrimonialRegimes().subscribe(x => {
      this.catalogPatrimonialRegimes = x;
    });
    this.employeeService.getCatalogMethodPayments().subscribe(x => {
      this.catalogMethodPayments = x;
    });
    this.employeeService.getCatalogBanks().subscribe(x => {
      this.catalogBanks = x;
    });
    this.employeeService.getCatalogTypesSalary().subscribe(x => {
      this.catalogTypesSalary = x;
    });
    this.employeeService.getCatalogSalaryZones().subscribe(x => {
      this.catalogSalaryZones = x;
    });
    this.employeeService.getCatalogFamilyMedicalUnits().subscribe(x => {
      this.catalogFamilyMedicalUnits = x;
    });
    this.employeeService.getCatalogAccountingSegments().subscribe(x => {
      this.catalogAccountingSegments = x;
    });
    this.employeeService.getCatalogBenefitCategories().subscribe(x => {
      this.catalogBenefitCategories = x;
    });
    this.catalogPaymentForms = this.positionService.getCatalogPaymentForms();
    this.catalogContractTypes = this.openingService.getCatalogContractTypes();
  }
  public getError(controlName: string): any {
    let error = '';
    let obj = {} as any;
    const control = this.formGeneralData.get(controlName);
    switch (controlName) {
      case 'stateBirth':
      case 'state':
      case 'maritalStatus':
      case 'schoolLevelId':
        if (control.errors != null) {
          error = JSON.stringify(control.errors);
          obj = JSON.parse(error);
        }
        break;
      default:
        if (control.touched && control.errors != null) {
          error = JSON.stringify(control.errors);
          obj = JSON.parse(error);
        }
        break;
    }

    return obj;
  }
  private initializeFormGeneralData() {
    this.formGeneralData = this.formBuilder.group({
      firstName: [null, [Validators.required, Validators.maxLength(50)]],
      lastName: [null, [Validators.required, Validators.maxLength(40)]],
      secondLastName: [null, [Validators.required, Validators.maxLength(40)]],
      birthDate: [null, Validators.required],
      stateBirthId: [null, Validators.required],
      gender: [null, Validators.required],
      curp: [null, [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
      rfc: [null, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      imss: [null, [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      email: [null, [Validators.required, Validators.email, Validators.maxLength(100)]],
      employeeNum: [null],
      trackingStatus: [null],
      hiringDate: [null],
      dismissalDate: [null],
      laborSeniorityDate: [null],
      dailySalary: [null],
      job: [null],
      positionNo: [null],
      companyName: [null],
      projectName: [null],
      planName: [null],
      customer: [null],
      zoneName: [null],
      townName: [null],
      businessPhone: [null],
      bossId: [null, Validators.required],
      supervisorId: [null, Validators.required],
      payrollOfficerId: [null, Validators.required],
      workingDayId: [null, Validators.required]
    });
  }
  private initializeFormStudy() {
    this.formStudy = this.formBuilder.group({
      schoolLevelId: [null, Validators.required],
      educationLevelId: [null, Validators.required],
      institute: [null, [Validators.required, Validators.maxLength(100)]],
      documentReceivedId: [null, Validators.required],
      periodFrom: [null, Validators.required],
      periodTo: [null, Validators.required]
    });
  }
  private initializeFormPersonalData() {
    this.formPersonalData = this.formBuilder.group({
      maritalStatusId: [null, Validators.required],
      personalNumber: [null, Validators.maxLength(10)],
      street: [null, [Validators.required, Validators.maxLength(100)]],
      interiorNumber: [null, Validators.maxLength(10)],
      externalNumber: [null, [Validators.required, Validators.maxLength(10)]],
      postalCode: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      suburb: [null, [Validators.required, Validators.maxLength(50)]],
      stateId: [null, Validators.required],
      townId: [null, Validators.required],
      patrimonialRegimeId: [null],
      country: [null],
      taxStreet: [null],
      taxInteriorNumber: [null],
      taxExternalNumber: [null],
      taxPostalCode: [null],
      taxSuburb: [null],
      taxState: [null],
      taxTown: [null],
      taxRegime: [null],
      taxIncorporationDate: [null],
      phoneCompanyId: [null, Validators.required],
      phonePlanId: [null, Validators.required]
    });
  }
  private initializeFormPaymentData() {
    this.formPaymentData = this.formBuilder.group({
      dailySalary: [null],
      integratedDailySalary: [null],
      bankId: [null, [Validators.required]],
      bankAccount: [null, [ Validators.maxLength(20)]],
      methodPaymentId: [null, [Validators.required]],
      classification: [null, [Validators.required]],
      typeSalaryId: [null, [Validators.required]],
      pantryAccount: [null, [ Validators.maxLength(16)]],
      pantryCard: [null, [Validators.maxLength(16)]],
      gasolineCard: [null, [ Validators.maxLength(16)]],
      gasolineIdentifier: [null, [ Validators.maxLength(6)]],
      interbankClabe: [null, [Validators.required, Validators.maxLength(18)]]
    });
  }
  private initializeFormBasicData() {
    this.formBasicData = this.formBuilder.group({
      subsidy: [null, Validators.required],
      requisitionContractTypeId: [null, Validators.required],
      laborSeniorityDate: [null],
      employerRegisterId: [null, [Validators.required]],
      salaryZoneId: [null, [Validators.required]],
      familyMedicalUnitId: [null, [Validators.required]],
      unionized: [null, [Validators.required]],
      accountingSegmentId: [null, [Validators.required]],
      individualAccount: [null, [Validators.required, Validators.maxLength(7)]],
      pieceWorker: [null, [Validators.required]],
      benefitCategoryId: [null, [Validators.required]],
      alimony: [null, [Validators.required]],
      hasInfonavit: [null, [Validators.required]]
    });
  }
  private submitFormStudy(section: string) {
    this.section = section;
    if (this.formStudy.valid) {
      let study = this.formStudy.value as IStudy;
      if (this.generalData.jobCandidateLevelEducation !== null) {
        study.id = this.generalData.jobCandidateLevelEducation.id === undefined ? null : this.generalData.jobCandidateLevelEducation.id;
      }
      study.jobCandidateId = this.generalData.id;
      this.addSwal.title = '¿Seguro que desea guardar los datos de estudios proporcionados?';
      this.addSwal.show().then((result) => {
        if (result.value) {
          this.processEmployeeStudy(study);
        }
      });
    } else {
      this.touchedControls(this.formStudy);
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private processEmployeeStudy(data: IStudy): void {
    this.employeeService.processEmployeeStudy(data)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.updateEmployeePayroll();
            let res = x.data as IStudy;
            if (data.id > 0) {
              this.generalData.jobCandidateLevelEducation.id = res.id;
            } else {
              this.generalData.jobCandidateLevelEducation = res;
            }
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private submitFormBasicData(section: string) {
    this.section = section;
    if (this.formBasicData.valid) {
      let basicData = this.formBasicData.value as IDtoEmployeeBasicData;
      if (this.generalData.employeeBasicData !== null) {
        basicData.id = this.generalData.employeeBasicData.id === undefined ? null : this.generalData.employeeBasicData.id;
      }
      basicData.jobCandidateId = this.generalData.id;
      this.addSwal.title = '¿Seguro que desea guardar los datos básicos proporcionados?';
      this.addSwal.show().then((result) => {
        if (result.value) {
          this.processEmployeeBasicData(basicData);
        }
      });
    } else {
      this.touchedControls(this.formBasicData);
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private processEmployeeBasicData(data: IDtoEmployeeBasicData): void {
    this.employeeService.processEmployeeBasicData(data)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.updateEmployeePayroll();
            let res = x.data as IDtoEmployeeBasicData
            if (data.id > 0) {
              this.generalData.employeeBasicData.id = res.id
            } else {
              this.generalData.employeeBasicData = res;
            }
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private submitFormPaymentData() {
    if (this.formPaymentData.valid) {
      let paymentData = this.formPaymentData.value as IDtoEmployeePaymentData;
      if (this.generalData.employeePaymentData !== null) {
        paymentData.id = this.generalData.employeePaymentData.id === undefined ? null : this.generalData.employeePaymentData.id;
      }
      paymentData.jobCandidateId = this.generalData.id;
      this.addSwal.title = '¿Seguro que desea guardar los datos de pago proporcionados?';
      this.addSwal.show().then((result) => {
        this.spinner.show();
        if (result.value) {
          this.employeeService.getEmployeeDataByBankAccount(paymentData.bankAccount, this.generalData.id).subscribe((x) => {
            let dataEmployee = x.data as IDtoPayrollEmployeeDetail
          if (dataEmployee == null){
            this.processEmployeePaymentData(paymentData);
          }
          else{
            this.addSwalBankAccount.title = `La cuenta ${paymentData.bankAccount} ya está asignada al trabajador ${dataEmployee.firstName} ${dataEmployee.lastName} ${dataEmployee.secondLastName}`;
            this.addSwalBankAccount.show();
            this.spinner.hide();
            return;
          }
          });
        }
      });
    } else {
      this.touchedControls(this.formPaymentData);
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
        this.spinner.hide();
    }
  }
  private processEmployeePaymentData(data: IDtoEmployeePaymentData): void {
    this.employeeService.processEmployeePaymentData(data)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.updateEmployeePayroll();
            let res = x.data as IDtoEmployeePaymentData;
            if (data.id > 0) {
              this.generalData.employeePaymentData.id = res.id;
            } else {
              this.generalData.employeePaymentData = res;
            }
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private submitFormPersonalData() {
    if (this.formPersonalData.valid) {
      let personalData = this.formPersonalData.value as IDtoPayrollEmployeeDetail;
      personalData.id = this.generalData.id;
      this.addSwal.title = '¿Seguro que desea guardar los datos personales proporcionados?';
      this.addSwal.show().then((result) => {
        if (result.value) {
          this.updateEmployeePersonalData(personalData);
        }
      });
    } else {
      this.touchedControls(this.formPersonalData);
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private updateEmployeePersonalData(data: IDtoPayrollEmployeeDetail): void {
    this.employeeService.updateEmployeePersonalData(data)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.updateEmployeePayroll();
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private submitFormGeneralData() {
    if (this.formGeneralData.valid) {
      let generalData = this.formGeneralData.value as IDtoPayrollEmployeeDetail;
      generalData.laborSeniorityDate = null;
      generalData.hiringDate = null;
      generalData.birthDate = new Date(this.configGeneral.dateFormat(generalData.birthDate, 'mm/dd/yyyy'));
      generalData.id = this.generalData.id;
      this.addSwal.title = '¿Seguro que desea guardar los datos generales proporcionados?';
      this.addSwal.show().then((result) => {
        if (result.value) {
          this.updateEmployeeGeneralData(generalData);
          this.updateSupervisor(this.generalData.jobCandidateRecruiterComment.positionId, +generalData.supervisorId);
          this.updateCoordinator(this.generalData.jobCandidateRecruiterComment.positionId, +generalData.bossId);
        }
      });
    } else {
      this.touchedControls(this.formGeneralData);
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private updateEmployeeGeneralData(data: IDtoPayrollEmployeeDetail): void {
    this.employeeService.updateEmployeeGeneralData(data)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.updateEmployeePayroll();
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private updateSupervisor(requisitionId: number, supervisorId: number): void {
    let dto = {} as IDtoRequisition;
    dto.id = requisitionId;
    dto.supervisorId = supervisorId;
    this.openingService.updateSupervisor(dto)
      .subscribe(
        (x) => {

        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private updateCoordinator(requisitionId: number, coordinatorId: number): void {
    let dto = {} as IDtoRequisition;
    dto.id = requisitionId;
    dto.coordinatorId = coordinatorId;
    this.openingService.updateCoordinator(dto)
      .subscribe(
        (x) => {

        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private addModuleLog(): void {
    let dto = {} as IDtoModuleLog;
    dto.table = "JobCandidates";
    dto.module = this.section;
    dto.action = this.action;
    dto.registryAffectedId = this.generalData.id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }
  private touchedControls(form: FormGroup): void {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  private getCatalogTowns(id: string): void {
    this.recruitmentService.getCatalogTownsByStateIdCodeNom(id).subscribe((res) => {
      this.formPersonalData.get('townId').setValue(null);
      this.catalogTowns = res;
      if (this.action === 'update') {
        this.formPersonalData.get('townId').setValue(this.generalData.townId.toString());
      }
    });
  }
  private mapDataUpdateEmployeePayroll(): IDtoEmployeeUpdatePayroll {
    let data = {} as IDtoEmployeeUpdatePayroll;
    data.employeeNum = this.formGeneralData.value.employeeNum;
    data.companyPay = this.requisitionPosition.companyPayId;
    data.payroll = this.requisitionPosition.codePayroll;
    data.firstName = this.formGeneralData.value.firstName;
    data.lastName = this.formGeneralData.value.lastName;
    data.secondLastName = this.formGeneralData.value.secondLastName;
    data.gender = this.formGeneralData.value.gender;
    data.birthDate = this.formGeneralData.value.birthDate;
    data.imss = this.formGeneralData.value.imss;
    data.rfc = this.formGeneralData.value.rfc;
    data.curp = this.formGeneralData.value.curp;
    data.countryBirth = '101';
    data.stateBirth = ('000' + this.formGeneralData.value.stateBirthId).slice(-'000'.length);
    data.email = this.formGeneralData.value.email;
    let valueWorkingDay = this.catalogWorkingDays.filter(x => x.id == this.formGeneralData.value.workingDayId)[0];
    let splitWorkingDay = valueWorkingDay.additional.split('|');
    data.group = splitWorkingDay[1];
    data.workingDay = splitWorkingDay[0];
    let maritalStatus = this.catalogMaritalStatus.filter(x => x.id == this.formPersonalData.value.maritalStatusId)[0];
    data.maritalStatus = maritalStatus.additional;
    if(this.formPersonalData.value.patrimonialRegimeId != null) {
      data.patrimonialRegime = this.catalogPatrimonialRegimes.filter(x => x.id == this.formPersonalData.value.patrimonialRegimeId)[0].additional;
    }
    data.street = this.formPersonalData.value.street;
    data.interiorNumber = this.formPersonalData.value.interiorNumber;
    data.externalNumber = this.formPersonalData.value.externalNumber;
    data.suburb = this.formPersonalData.value.suburb;
    data.postalCode = this.formPersonalData.value.postalCode;
    data.countryResidence = '101';
    data.stateResidence = ('000' + this.formPersonalData.value.stateId).slice(-'000'.length);
    data.townResidence = this.catalogTowns.filter(x => x.id == this.formPersonalData.value.townId)[0].additional;
    data.personalNumber = this.formPersonalData.value.personalNumber;
    if(this.formPaymentData.value.methodPaymentId != null) {
      data.methodPayment = this.catalogMethodPayments.filter(x => x.id == this.formPaymentData.value.methodPaymentId)[0].additional;
    }
    if(this.formPaymentData.value.bankId != null) {
      data.bank = this.catalogBanks.filter(x => x.id == this.formPaymentData.value.bankId)[0].additional;
    }
    data.bankAccount = this.formPaymentData.value.bankAccount;
    if(this.formPaymentData.value.typeSalaryId != null) {
      data.typeSalary = this.catalogTypesSalary.filter(x => x.id == this.formPaymentData.value.typeSalaryId)[0].additional;
    }
    data.subsidy = this.formBasicData.value.subsidy;
    data.requisitionContractType = ('00' + this.formBasicData.value.requisitionContractTypeId).slice(-'00'.length);
    data.location = this.formBasicData.value.employerRegisterId;
    data.salaryZone = this.catalogSalaryZones.filter(x => x.id == this.formBasicData.value.salaryZoneId)[0].additional;
    data.familyMedicalUnit = this.catalogFamilyMedicalUnits.filter(x => x.id == this.formBasicData.value.familyMedicalUnitId)[0].additional;
    data.unionized = this.formBasicData.value.unionized;
    data.accountingSegment = this.catalogAccountingSegments.filter(x => x.id == this.formBasicData.value.accountingSegmentId)[0].additional;
    data.individualAccount = this.formBasicData.value.individualAccount;
    data.pieceWorker = this.formBasicData.value.pieceWorker;
    data.benefitCategory = this.catalogBenefitCategories.filter(x => x.id == this.formBasicData.value.benefitCategoryId)[0].additional;
    data.pantryAccount = this.formPaymentData.value.pantryAccount;
    data.pantryCard = this.formPaymentData.value.pantryCard;
    data.gasolineCard = this.formPaymentData.value.gasolineCard;;
    data.gasolineIdentifier = this.formPaymentData.value.gasolineIdentifier;

    const result = this.catalogEmployees.filter(x => x.id === this.formGeneralData.value.bossId);
    if (result.length == 0)
    {
      data.nameCoordinator = '0';
    }
    else{
    data.nameCoordinator = result[0].name;
    };

    return data;
  }
  private updateEmployeePayroll(): void {
    let dto = this.mapDataUpdateEmployeePayroll();
    this.payrollService.updateEmployeePayroll(dto)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private updateTaxData(): void {
    let dto = {} as IDtoEmployeeUpdatePayroll;

    dto.street = this.formPersonalData.value.taxStreet;
    dto.interiorNumber = this.formPersonalData.value.taxInteriorNumber;
    dto.externalNumber = this.formPersonalData.value.taxExternalNumber;
    dto.postalCode = this.formPersonalData.value.taxPostalCode;
    dto.suburb = this.formPersonalData.value.suburb;
    dto.stateResidence = this.formPersonalData.value.taxState;
    dto.townResidence = this.formPersonalData.value.taxTown;
    dto.uKey = this.generalData.uKey;
    dto.employeeId = this.generalData.id;
    this.recruitmentService.updateTaxDataEmployee(dto)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
}
